<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card ">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-9">
                            <h5 class="card-title mb-4">Taxes</h5>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-primary btn-block"
                                            @click="handleBtnNew">
                                <i class="mdi mdi-plus"></i>Add New Tax
                            </button>
                        </div>
                    </div>
                    
                    <div class="table-responsive w-100">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">No.</th>
                                    <th class="border-bottom-0">Name</th>
                                    <th class="border-bottom-0">Value</th>
                                    <th class="border-bottom-0"></th>
                                    <th class="border-bottom-0"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(t, index) in taxes">
                                    <td> {{ index + 1 }} </td>
                                    <td> {{ t.taxName }} </td>
                                    <td class="table-longdescription"> {{ t.value }} </td>
                                    <td class="table-button">
                                        <b-button-group>
                                            <b-button variant="primary" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnEdit(t)">
                                                <i class="mdi mdi-table-edit"></i>
                                            </b-button>
                                            <b-button variant="danger" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnDelete(t)">
                                                <i class="mdi mdi-delete-forever"></i>
                                            </b-button>
                                        </b-button-group>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script>
import { mapState } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
export default {
    name : 'taxes',
    extends: RestaurantChangedBase,
    computed: {
      ...mapState({
          taxes: state => state.taxes.taxes
      })
    },
    methods : {
        handleBtnNew() {
            this.$router.push( { name: 'taxaddform' });
        },
        handleBtnEdit() {

        },
        handleBtnDelete() {

        }
    },
    async created() {
      await this.$store.dispatch('restaurants/getRestaurantsAction');
      this.$store.dispatch('taxes/getTaxesAction');
      this.setAction('taxes/getTaxesAction')
    }
    
    
}
</script>
